import React, { useState, useEffect } from 'react'
import { IoMdRefresh } from "react-icons/io";
import Box from "@mui/material/Box";
import getData from "../../Custome_Components/commonAPISelect";
import getData2 from "../../Custome_Components/commonAPISelect2";
import { toast } from "react-toastify";
import { IoSend } from "react-icons/io5";
import { BsChatText } from "react-icons/bs";

const ActivityLog = (props) => {
    const { ComplaintIDPK, Modalloading, TaskStatusIDPK } = props;
    const [logResponse, setLogResponse] = useState();
    const [messageResponse, setMessageResponse] = useState("");
    const username = localStorage.getItem("username") || "";

    useEffect(() => {
        getmessage();
    }, []);

    useEffect(() => {
        if (containsApostrophe(messageResponse)) {
            const RemovedApostrophes = removeApostrophes(messageResponse);
            setMessageResponse(RemovedApostrophes);
        }
    }, [messageResponse]);

    function containsApostrophe(str) {
        if (str) {
            return str.includes("'");
        }
    }
    function removeApostrophes(str) {
        if (str) {
            return str.replace(/'/g, "");
        }
    }

    const getmessage = async () => {
        try {
            Modalloading(true);
            const result = await getData2("DashboardService/VwAPINSEIPLDetailsNew/", {
                data: {
                    p1_int: 77,
                    p2_int: ComplaintIDPK ? ComplaintIDPK : "",
                },
            });

            const {
                Output: { status, data },
            } = result;
            if (status.code == "200") {
                setLogResponse(data);
            } else {
                console.error("Error fetching data:", status.message);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            Modalloading(false);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleIconClick();
        }
    };

    const handleIconClick = async () => {
        try {
            const result = await getData2("DashboardService/VwAPINSEIPLDetailsNew/", {
                data: {
                    p1_int: 78,
                    p2_int: ComplaintIDPK ? ComplaintIDPK : "",
                    P9_varchar: messageResponse,
                    UserID_int: localStorage.getItem("EmpID"),
                },
            });
            const {
                Output: { status },
            } = result;
            if (status.code == "200") {
                toast.success("Comment Added successfully");
                setMessageResponse("");
                getmessage();
            } else {
                console.error("Error fetching data:", status.message);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    return (
        <div
            style={{
                backgroundColor: "#F0F0F0",
                height: "100%",
                position: "relative",
                width: '100%',
                borderBottomRightRadius: "12px"
            }}
        >
            <div className="IsNameActiveLog4">
                <div className="IsNameActiveLog5">
                    <div className="IsNameActiveLog6">
                        <BsChatText className="IsNameActiveLog7" />
                        <span className="IsNameActiveLog8">Activity Log</span>
                    </div>
                    <IoMdRefresh style={{ fontSize: "20px", color: "#4b4b4b", cursor: "pointer" }} onClick={() => getmessage()} />
                </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", height: "calc(100% - 36px)" }}>
                <div
                    style={{
                        flex: "1",
                        backgroundColor: "#F0F0F0",
                        overflowY: "auto",
                        padding: "7px",
                        boxSizing: "border-box",
                        borderRadius:"12px"
                    }}
                >
                    <Box
                        sx={{ display: "flex", flexDirection: "column", flex: 1 }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: "auto",
                                overflowX: "hidden",
                                padding: "10px",
                            }}
                        >
                            {logResponse &&
                                Array.isArray(logResponse) &&
                                logResponse.length > 0
                                ? logResponse.map((val, index) => {
                                    if (username.toLowerCase() ===
                                        (val?.EmployeeName || "").toLowerCase()
                                    ) {
                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginBottom: "10px",
                                                    gap: "6px",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        backgroundColor: "white",
                                                        borderRadius: "10px",
                                                        padding: "8px 10px",
                                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                                        overflow: "hidden",
                                                        wordWrap: "break-word",
                                                        wordBreak: "break-word",
                                                        width: "100%",
                                                        maxWidth: "70%",
                                                        alignSelf: "flex-end",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontWeight: "500", fontSize: "12px", letterSpacing: "0.4px", color: "#515151"
                                                        }}
                                                    >
                                                        {val?.EmployeeName || "No Name"}
                                                    </span>
                                                    <span style={{
                                                        fontSize: "14px", letterSpacing: "0.4px", color: "#515151"
                                                    }}>
                                                        {val?.Remarks || "No Message"}
                                                    </span>
                                                </div>

                                                <div style={{
                                                    display: "flex", width: "36px", height: "36px",
                                                    borderRadius: "50%", backgroundColor: "#bababa",
                                                    fontSize: "18px", alignItems: "center",
                                                    justifyContent: "center", color: "#fff"
                                                }}>
                                                    {val?.EmployeeName?.charAt(0)}
                                                </div>

                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginBottom: "10px",
                                                    gap: "6px",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <div style={{
                                                    display: "flex", width: "36px", height: "36px",
                                                    borderRadius: "50%", backgroundColor: "#bababa",
                                                    fontSize: "18px", alignItems: "center",
                                                    justifyContent: "center", color: "#fff"
                                                }}>
                                                    {val?.EmployeeName?.charAt(0)}
                                                </div>

                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        backgroundColor: "white",
                                                        borderRadius: "10px",
                                                        padding: "10px",
                                                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                                        overflow: "hidden",
                                                        wordWrap: "break-word",
                                                        wordBreak: "break-word",
                                                        width: "100%",
                                                        maxWidth: "70%",
                                                        alignSelf: "flex-start",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontWeight: "500", fontSize: "12px", letterSpacing: "0.4px"
                                                        }}
                                                    >
                                                        {val?.EmployeeName || "No Name"}
                                                    </span>

                                                    <span style={{
                                                        fontSize: "14px", letterSpacing: "0.4px"
                                                    }}>
                                                        {val?.Remarks || "No Message"}
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    }
                                })
                                : null}
                        </Box>
                    </Box>
                </div>

                {/* {TaskStatusIDPK != 1 &&  */}
                <div
                    style={{
                        backgroundColor: "#F0F0F0",
                        padding: "10px 10px 14px 10px",
                        boxSizing: "border-box",
                        display: "flex",
                        flexDirection: "column",
                        borderBottomRightRadius: "12px"
                    }}
                >
                    <span style={{ color: "#515151", fontSize: "14px", letterSpacing: "0.4px" }}>Comment</span>

                    <div className="TaskDetInputContainer">
                        <input
                            type="text"
                            value={messageResponse}
                            placeholder="Text here"
                            className="TaskDetInput"
                            onChange={(e) => setMessageResponse(e.target.value)}
                            onKeyDown={handleKeyPress}
                        />
                        <IoSend onClick={handleIconClick} className="TaskDetIcon" />
                    </div>
                </div>
                {/* // } */}
            </div>
        </div>
    )
}

export default ActivityLog
